export default __webpack_public_path__ + "static/media/melanau2.1999c7ad.png";